import { BaseSubject } from '../BaseSubject.model';
import store from '@/store/index';

import { TAG_P_HEIGHT } from '@/subjects/constant';
import { PADDING_TOP } from '../constant';
let answerPanelState = store.state.answerPanel;
const NONANSWER_HEIGHTH = 100; //解答题默认高度
const TH_HEIGHT = 10;

export class nonAnswerAreaModel extends BaseSubject {
  constructor(data = {}) {
    super(data);
    this.height = data.height || 100;       // 默认高度100px
    this.type = 7;      // 区域类型
    this.id = `nra_${Date.now()}`;   

    if (data.items && data.items.length) {
      this.items = [];
      this.items.push({
        no: 1,
        score: 0,
      });
      this.items = data.items;
      const hash = {};
      this.items = this.items.reduce((item, next) => {
        hash[next.no] ? '' : (hash[next.no] = true && item.push(next));
        return item;
      }, []); // 对象数组去重
    } else {
      this.items.push({
        no: 1,
        score: 0,
      });
    }
  }
  render(options = {}) {
    const { hurdleReset } = options; // 不是通过二栏三栏render的
    const items = this.items;

    const htmlArray = [];
    for (let index = 0; index < items.length; index++) {
      const item = items[index];
      item['innerHTML'] = `<div class="non-answer-text">请勿在此区域作答</div>`;
      item['initDragHeight'] = this.height || NONANSWER_HEIGHTH;
      htmlArray.push({ ...item });
    }
    this.items = items;
    if (!hurdleReset && this.htmlArray.length && !this.fromEdit) {
    } else {
      this.htmlArray = htmlArray;
    }
    console.log(this.htmlArray);
    this.end = ''
    this.score = 0;
 }
   deleteItem(index) {
    this.items.splice(index, 1);
  }

  appendToPage(state, pageHeight, newTopicHeight) {
    state.answerTopicAdded = [];
    state.answerSignal = true;
    let isCurrentPage = state.pageCell.length - 1;
    const isHeight = this.page.isSurplusPage(state, isCurrentPage, TH_HEIGHT + NONANSWER_HEIGHTH);
    console.log(" nonAnswerAreaModel ：：appendToPage::::::", isHeight);
      this.htmlArray.forEach((html, index) => {
        // state.pageCell[state.pageCell.length - 1].items.push(this.);
        state.answerTopicAdded.push({
          ...html,
          name: '禁止作答区域',
          totalScore: 0,
          end: this.end,
          th: this.th,
          type: this.type,
          thList: undefined,
          hasTitle: false,
          type: this.type,
          isHurdle: false,
          initDragHeight: html.initDragHeight || NONANSWER_HEIGHTH,
          // 初始化拖拽高度（如果是弹窗生成的题目高度是由数据生产者计算编辑器空格生成的高度，不需要initDragHeight，如果是拖拽生成的高度就是这个属性）
          innerHTML: html.innerHTML,
        });
      });
      let currentPage = state.pageCell.length - 1;
      if (this.page.isSurplusPage(state, currentPage, TAG_P_HEIGHT)) {
        state.newTopicHeight = this.items.length * NONANSWER_HEIGHTH; // 算上标题的总高度
        let cloneTopicList = JSON.parse(
          JSON.stringify(state.pageCell[state.pageCell.length - 1].fillTopiclist)
        );
        cloneTopicList = [...cloneTopicList, ...state.answerTopicAdded];
        // state.pageCell[state.pageCell.length - 1].fillTopiclist = [
        //   ...state.pageCell[state.pageCell.length - 1].fillTopiclist,
        //   ...state.answerTopicAdded,
        // ];
        this.currentPage = state.pageCell.length - 1;
        this.recursionCutAnswerPage(state, currentPage, state.existHeight, undefined, false);
        this.afterAppendToPage(state, currentPage, 0);
      } else {
        this.page.createNextPage(state.pageCell);
        currentPage++;
        state.newTopicHeight = this.items.length * NONANSWER_HEIGHTH + TH_HEIGHT; // 算上标题的总高度
        // state.pageCell[currentPage].fillTopiclist = [
        //   ...state.pageCell[currentPage].fillTopiclist,
        //   ...state.answerTopicAdded,
        // ];
        this.currentPage = state.pageCell.length - 1;
        this.recursionCutAnswerPage(state, currentPage, 0, undefined, false);
        this.afterAppendToPage(state, currentPage, 0);
      }
      // throw new Error('Method not implemented.');
 }

 afterAppendToPage(state, currentPage, existHeight) {
    const canFillHeight = this.page.getPageSurplus(state, currentPage);
    //console.log('非作答区域：canFillHeight:::', canFillHeight);
    state.pageCell[state.pageCell.length - 1].canFillHeight = canFillHeight
    return canFillHeight;
 }
 /**
    * 递归更新纸张高度
    */
   recursionCutAnswerPage(state, currentPage, existHeight, currentTopicStackList, isSellCall) {

     currentTopicStackList = JSON.parse(
       JSON.stringify(currentTopicStackList || state.answerTopicAdded)
     );
     let { acCardYJType } = answerPanelState.answerSheet;
     let cardGapHeight = acCardYJType == 2 ? 34 : 0
     existHeight = existHeight + cardGapHeight;
 
     // currentTopicStackList = JSON.parse(JSON.stringify(currentTopicStackList));
     const currentMaxHeight = state.pageCell[currentPage].contentHeight;
     const canFillHeight = currentMaxHeight - existHeight; // 可填充高度
     let topicHeight = state.newTopicHeight + cardGapHeight;
     if (topicHeight > canFillHeight) {
       // 当有存在高度的时候 大于存在高度跨栏 topicHeight减去填充高度 超出高度insert下一页 循环
       let newFillTopicList = [];
       topicHeight -= isSellCall ? currentMaxHeight : canFillHeight; // 当上面没有已存在的高度可以直接减去currentMaxHeight
       state.newTopicHeight = topicHeight;
       // const yushuHeight = canFillHeight % ANSWER_HEIGHTH; //取余
       currentTopicStackList.forEach((item, index) => {
         state.pageCell[currentPage].fillTopiclist.push({
           th: this.th,
           ...item,
           isHurdle: true,
           initDragHeight: canFillHeight - TH_HEIGHT,
           innerHTML: currentTopicStackList[currentTopicStackList.length - 1].innerHTML,
         });
       });
      
       this.page.createNextPage(state.pageCell);
       currentPage++;
       const lastStack = currentTopicStackList[currentTopicStackList.length - 1];
       this.page.insertNextPageHeadStack(
         state.pageCell[currentPage],
         topicHeight + PADDING_TOP,
         this.type,
         undefined,
         undefined,
         lastStack.no
       );

     } else {
       currentTopicStackList.forEach(item => {
         state.pageCell[currentPage].fillTopiclist.push(item);
       });
 
       // state.loadingInstance.close();
       return console.log('停止递归');
     }
   }
}